import mutations from "../glob/mutations";
import getters from "../glob/getters";
import { DataService } from "../../../config/dataService/dataService";

const state = () => ({
  loading: false,
  error: null,
  statusCode: false,
  currentUser: [],
  institutions: [],
  skills: [],
  companies: [],
  languageSkills: [],
  softSkills: [],
  technicalSkills: [],
  certifiedSkills: [],
  statistics: [],
});

const actions = {
  async getInstitutions({ commit }) {
    try {
      let institutions = await DataService.get("public/institution").then(
        (res) => res
      );
      commit("SET_GET_INSTITUTIONS", institutions);
    } catch (err) {
      return err;
    }
  },

  async addInstitutions({ commit }, name) {
    try {
      let res = await DataService.post(`public/institution/${name}`, {
        name: name,
      }).then((res) => res);
      commit("SET_GET_INSTITUTIONS", res);
      return res;
    } catch (err) {
      return err;
    }
  },

  async getSkills({ commit }) {
    try {
      let skills = await DataService.get("public/skill").then((res) => res);
      commit("SET_GET_SKILLS", skills.data.data);
    } catch (err) {
      return err;
    }
  },

  async checkSkillExists(name) {
    try {
      let res = await DataService.get("public/skill", { name: name }).then(
        (res) => res
      );
      return res;
    } catch (err) {
      return err;
    }
  },

  async getLanguageSkill({ commit }) {
    try {
      let skills = await DataService.get("public/skill/language").then(
        (res) => res
      );
      commit("SET_GET_LANGUAGE_SKILLS", skills.data.data);
    } catch (err) {
      return err;
    }
  },

  async getSoftSkills({ commit }) {
    try {
      let skills = await DataService.get("public/skill/soft").then(
        (res) => res
      );
      commit("SET_GET_SOFT_SKILLS", skills.data.data);
    } catch (err) {
      return err;
    }
  },

  async getTechnicalSkills({ commit }) {
    try {
      let skills = await DataService.get("public/skill/technical").then(
        (res) => res
      );
      commit("SET_GET_TECHNICAL_SKILLS", skills.data.data);
    } catch (err) {
      return err;
    }
  },

  async getCertifiedSkills({ commit }) {
    try {
      let skills = await DataService.get("public/skill/certified").then(
        (res) => res
      );
      commit("SET_GET_CERTIFIED_SKILLS", skills.data.data);
    } catch (err) {
      return err;
    }
  },

  async postCompany(context, name) {
    try {
      let res = await DataService.post(`public/companies/${name}`, {
        name: name,
      });
      if (res.status === 200) {
        let getArr = Object.values(res.data.data);
        return getArr[0].id;
      }
    } catch (err) {
      return err;
    }
  },

  async registerCandidate(context, data) {
    let test = JSON.stringify(data);
    try {
      let res = await DataService.post("public/candidate/register", test).then(
        (res) => res
      );
      if (res.data.status === true) {
        return res.data.status;
      }
    } catch (err) {
      return err;
    }
  },

  async addNewSkill({ commit }, data) {
    try {
      let res = await DataService.post(
        `public/skill/${data.skill_type}/${data.name}`,
        {
          skill_type: data.skill_type,
          name: data.name,
        }
      ).then((res) => res);
      if (res.data.status) {
        let getArr = Object.values(res.data.data);
        commit("SET_ADD_NEW_SKILL", res.data);
        return getArr[0].id;
      }
    } catch (err) {
      return err;
    }
  },
  async getStats({ commit }) {
    try {
      let res = await DataService.get(`public/stats`).then((res) => res);
      commit("SET_GET_STATS", res);
    } catch (error) {
      return error;
    }
  },
};

export default {
  namespaced: false,
  state,
  actions,
  mutations,
  getters,
};
